import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaCheck } from 'react-icons/fa';
import styles from './styles.module.css';

/**
 * "What's included" — the row list a buyer scans before they read anything.
 *
 * Rows come from the feature's registry entry rather than from the translation
 * file, so a page cannot quietly grow a row that has no copy behind it: the
 * locale-completeness test derives what must exist from this same list.
 */
const SpecTable = ({ scope = 'features', featureKey, rows = [], color = '#F36523' }) => {
  const { t } = useTranslation();
  if (!rows.length) return null;

  return (
    <section className={styles.section}>
      <div className="container">
        <h2 className={styles.title} data-aos="fade-up">
          {t('features.common.specTitle', "What's included")}
        </h2>

        <dl className={styles.list}>
          {rows.map((row, i) => (
            <div key={row} className={styles.row} data-aos="fade-up" data-aos-delay={i * 60}>
              <span className={styles.tick} style={{ background: `${color}18`, color }}>
                <FaCheck aria-hidden="true" />
              </span>
              <div className={styles.rowText}>
                <dt>{t(`${scope}.${featureKey}.spec.${row}.t`)}</dt>
                <dd>{t(`${scope}.${featureKey}.spec.${row}.d`)}</dd>
              </div>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
};

export default SpecTable;
